export default __webpack_public_path__ + "static/media/right-arrow.164a8915.svg";